/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Error"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-4QcjJ': isBefore ? 0 : 1,'--ty-2-4QcjJ': isBefore ? "8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="There was a problem loading the questions."
/>
</div>
{children}
</React.Fragment>)
}